<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  <div class='global-panel' v-loading.body="loading.main">
    <div class="global-header">
      <div class="global-title">上传/日志工具</div>
      <div class='global-tbar'>

        <el-input size="small" v-model="condition.threadNo" placeholder="线程号"></el-input>
        <el-select size="small" v-model="condition.logType" clearable placeholder="日志类型">
          <el-option label="业务" value="业务"> </el-option>
          <el-option label="普通" value="普通"> </el-option>
        </el-select>
        <el-input size="small" v-model="condition.logDesc" placeholder="简述"></el-input>
        <el-input size="small" v-model="condition.logIp" placeholder="IP"></el-input>
        <el-input size="small" v-model="condition.logUser" placeholder="用户"></el-input>
        <el-input size="small" v-model="condition.msg" placeholder="内容"></el-input>
        <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <div class="global-header">
      <div class='global-tbar'>
        <el-input size="small" v-model="condition.logTimeStart" placeholder="开始时间"></el-input>
        <el-input size="small" v-model="condition.logTimeEnd" placeholder="结束时间"></el-input>

        <el-button size="small" type="danger"  @click="cleanDB()">清空DB</el-button>
        <div style="line-height: 30px">只能上传log文件，且不超过1G</div>
        <el-upload action="rest/sys/logAnalysis/upload" multiple :limit="1" accept=".log" :show-file-list="false"
                   :file-list="logFileList"
                   :before-upload="handleBeforeUpload"
                   :on-exceed="handleExceed"
                   :on-success="handleSuccess"
                   :on-error="handleError">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
      <el-table :data="dataList" border stripe style="width: 100%" size="mini" highlight-current-row >
        <el-table-column prop="logTime" label="时间" width="170"></el-table-column>
        <el-table-column prop="threadNo" label="线程号" width="160"></el-table-column>
        <el-table-column prop="className" label="类名" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="methodName" label="方法名" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="logType" label="类型" width="60" show-overflow-tooltip></el-table-column>
        <el-table-column prop="logDesc" label="简述" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="msg" label="内容" min-width="60" show-overflow-tooltip></el-table-column>
        <el-table-column prop="logIp" label="IP" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="logUser" label="用户" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="70" align="center">
          <template slot-scope="scope">
            <el-button class="global-text-btn-success" size="mini" type="text" @click="showData(scope.row)">明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页  -->
      <div v-show="paging.allNum > paging.everySize" class="global-paging">
        <hr/>
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
    </div>
  </div>
  <el-dialog :visible.sync="visible.detail" width="70%" v-loading="loading.param" :close-on-click-modal="false" :close-on-press-escape="false">
    <div>
      <span style="color: #dd6161">时间:</span>
      <span>{{currentRecord.logTime}}</span>
      <span style="color: #dd6161;padding-left: 20px">线程号:</span>
      <span>{{currentRecord.threadNo}}</span>
    </div>
    <div>
      <span style="color: #dd6161">类名:</span>
      <span>{{currentRecord.className}}</span>
      <span style="color: #dd6161;padding-left: 20px">方法名:</span>
      <span>{{currentRecord.methodName}}</span>
    </div>
    <div>
      <span style="color: #dd6161">IP:</span>
      <span>{{currentRecord.logIp}}</span>
      <span style="color: #dd6161;padding-left: 20px">用户:</span>
      <span>{{currentRecord.logUser}}</span>
      <span style="color: #dd6161;padding-left: 20px">类型:</span>
      <span>{{currentRecord.logType}}</span>
      <span style="color: #dd6161;padding-left: 20px">简述:</span>
      <span>{{currentRecord.logDesc}}</span>

    </div>
    <br>
    <div>
      <span style="color: #dd6161">日志信息:</span><br>
      <span>{{currentRecord.msg}}</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible.detail = false">关闭</el-button>
    </span>
  </el-dialog>
</div>

</template>

<script>

export default {
  name: 'LogAnalysis',
  data () {
    return {
      // 遮罩
      loading: {main: false, detail: false},
      // 可见
      visible: {detail: false},
      // 日志文件
      logFileList: [],
      // 条件
      condition: {},
      // 结果
      dataList: [],
      // 当前记录
      currentRecord: {},
      // 分页
      paging: {currPage: 1, everySize: 50, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
  },
  
  methods: {
    /*
    * 查询所有
    */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/sys/logAnalysis/findByCondition', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 更新数据
        vm.dataList = response.body.dataList;
        vm.paging = response.body.pagingBean;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    cleanDB: function (record) {
      var vm = this;
      vm.$confirm('确定要【清空】数据库中的日志吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/sys/logAnalysis/cleanDB').then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition();
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    handleBeforeUpload(file) {
      var vm = this;
      const isLOG = file.name.substr(file.name.lastIndexOf(".")+1) === 'log';
      const isLtSize = file.size < 1*1024*1024*1024;

      if (!isLOG) {
        vm.$message.error('上传格式只能是 LOG 格式!');
      }
      if (!isLtSize) {
        vm.$message.error('上传文件大小不能超过 1G!');
      }
      if(isLOG && isLtSize){
        vm.loading.main = true;
      }
      return isLOG && isLtSize;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleSuccess(response, file, fileList) {
      var vm = this;
      vm.loading.main = false;
      if(response.status=='success'){
        vm.$message.success(response.msg);
      } else {
        vm.$message.error(response.msg);
      }
      vm.logFileList = [];
      vm.findByCondition();
    },
    handleError(err, file, fileList) {
      var vm = this;
      vm.loading.main = false;
      vm.$message.error("文件上传失败");
      vm.logFileList = [];
    },
    showData: function (record) {
      var vm = this;
      vm.currentRecord = JSON.parse(JSON.stringify(record));
      vm.visible.detail = true;
    }
  }
}
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/system/loganalysis/LogAnalysis.vue